import * as Types from '../constants/actionTypes';

export default (state = {emailNotificationList: []}, action) => {
    switch (action.type) {
        case Types.EMAIL_NOTIFICATION_DETAIL_SUCCESS:
            return Object.assign({}, state, { emailNotificationList: action.payload || [] })
        case Types.EMAIL_NOTIFICATION_ADDED_SUCCESS:
            state.emailNotificationList.push(action.payload)
            return {
                ...state
            }
        case Types.EMAIL_NOTIFICATION_DELETED_SUCCESS:
            state.emailNotificationList.splice(action.deleteIndex,1)
            return {
                ...state
            }
        case Types.EMAIL_NOTIFICATION_UPDATE_SUCCESS:
            state.emailNotificationList[action.updateIndex] = action.payload
            return {
                ...state
            }
        case Types.EMAIL_NOTIFICATION_DETAIL_ERROR:
           return {
            emailNotificationError: action.emailNotificationError
            }
        case Types.EMAIL_NOTIFICATION_COUNT_SUCCESS:
            return {
                emailNotificationCount: action.payload
            }         
        case Types.GET_COUNTRY_EMAIL_NOTIFICATIONS:
            return Object.assign({}, state, { getCountryEmailNotifications: action.payload || [] }) 
        default:
            return state
    }
}